<template>
   <div>
    <div class="ui comments" style="max-width:none">
        <h3 class="ui dividing header">Comments</h3>
        <!--<i class="plus icon" style="position:absolute;right:20px;top:50px" ></i>-->
        <div v-if="!all_notes_view" class="ui toggle checkbox " style="margin-right:1em;position:absolute;right:20px;top:52px">
            <input type="checkbox" name="related" v-model="show_concordances">
            <label style="padding-left:4em">Show Related Comments</label>
        </div>
        <div v-if="all_notes_view" class="ui secondary menu">
            <div class="ui item" style="margin:0px;padding:0px">
                <div class="ui toggle checkbox ">
                    <input type="checkbox" name="my_comments" v-model="my_comments">
                    <label style="padding-left:4em">My Comments</label>
                </div>
            </div>
            <div class="ui item">
                <div class="ui toggle checkbox ">
                    <input type="checkbox" name="general_comments" v-model="general_comments">
                    <label style="padding-left:4em">General Comments</label>
                </div>
            </div>
            <div class="right menu" style="padding-top: 10px;">
                Sort by -
                <div class="ui inline dropdown" id="sort_by" style="margin-left:5px;">
                    <div class="text">
                        Items <i class="sort amount up icon" style="margin: 0px 15px 0px 0px;"></i>
                    </div>
                    <i class="dropdown icon"></i>
                    <div class="menu">
                        <div class="item" data-value='0'>
                            Items <i class="sort amount up icon" style="margin: 0px 15px 0px 0px;"></i>
                        </div>
                        <div class="item" data-value='1'>
                            Items <i class="sort amount  down icon" style="margin: 0px 15px 0px 0px;"></i>
                        </div>
                        <div class="item" data-value='2'>
                            Date <i class="sort amount  up icon" style="margin: 0px 15px 0px 0px;"></i>
                        </div>
                        <div class="item" data-value='3'>
                            Date <i class="sort amount  circle down icon" style="margin: 0px 15px 0px 0px;"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <form class="ui reply form" id="add_comment">
            <input v-if="!all_notes_view" type="hidden" name="items" id="items" v-bind:value="[primary_item]">
            <div class="field">
                <textarea name="note" id="note" placeholder="Add your new comment..." style="height:8em"></textarea>
            </div>
            <div class="ui right blue labeled submit icon button">
                <i class="icon edit"></i> Add Comment
            </div>
        </form>
        <br>
        <div v-if="!loading" id="loading">
            <div v-for="note in noteList" :key="note.uuid" class="ui centered grid">
                <div class="fourteen wide column">
                    <div class="comment">
                        <span class="avatar">
                            <img v-if="note.hasOwnProperty('avatar')" v-bind:src="'/static/avatars/'+note.avatar+'.png'">
                            <div v-else style="position:relative;">
                                <img src="/static/icon-background.png">
                                <div class="initials" v-html="extractInitials(note.created_by)"></div>
                            </div>
                        </span>
                        <div class="content">

                            <span class="author">{{note.created_by}}</span>
                            <div class="metadata">
                                <span class="date">{{formatDate(note.updated)}}</span>&nbsp;
                                <span v-if="show_concordances && !all_notes_view" class="item_id">({{note.items[0]}})</span>

                            </div>
                            <form v-if="note.uuid==editNote" class="ui reply form" v-bind:id="'form-'+note.uuid">
                                <input type="hidden" name="uuid" v-bind:value="note.uuid">
                                <div class="field">
                                    <textarea style="min-height:8em;" v-bind:id="'edit-'+note.uuid" name="note">{{note.note}}</textarea>
                                </div>
                                <div class="ui blue submit button">Save</div>
                                <div class="ui red cancel button" v-on:click="cancel()">Cancel</div>
                            </form>
                            <div v-if="note.uuid!=editNote">
                                <div class="text" v-bind:id="'note-'+note.uuid" v-html="note.note.replace(/\r\n/g,'<br>')"></div>
                                <div class="actions">
                                    <a v-if="!note.hasOwnProperty('replies')" class="reply" v-on:click="add_reply(note.uuid)">Reply</a>
                                    <span v-else class="reply">&nbsp;</span>
                                    <span style="position:absolute;right:0px">
                                        <i v-if="auth.role=='admin' || (auth.role=='contributor' && auth.uuid==note.created_by_id) " class="edit outline icon" v-on:click="edit(note.uuid)" style="cursor:pointer"></i>
                                        <i v-if="auth.role=='admin' || (auth.role=='contributor' && auth.uuid==note.created_by_id) " class="trash alternate outline icon" v-on:click="delete_note(note.uuid)" style="cursor:pointer"></i>
                                    </span>
                                </div>
                            </div>
                            <form v-if="note.uuid==addReply" class="ui reply form" id='reply'>
                                <input v-if="note.hasOwnProperty('items')" type="hidden" name="items" id="items" v-bind:value="[note.items[0]]">
                                <!-- <input v-else type="hidden" name="items" id="items" value="">-->
                                <input type="hidden" name="reply_to" v-bind:value="note.uuid">
                                <div class="field">
                                    <textarea style="height:8em" id="reply-note" name="note"></textarea>
                                </div>
                                <div class="ui blue labeled submit icon button">
                                    <i class="icon edit"></i> Add Reply
                                </div>
                                <div class="ui red cancel button" v-on:click="cancel()">Cancel</div>
                            </form>
                        </div>
                        <!-- *********Replies***********-->
                        <div v-if="note.hasOwnProperty('replies')" class="comments">
                            <div v-for="(reply,index) in note.replies" :key="reply.uuid" class="comment">
                                <span class="avatar">
                                    <img v-if="reply.hasOwnProperty('avatar')" v-bind:src="'/static/avatars/'+reply.avatar+'.png'">
                                    <div v-else style="position:relative;">
                                        <img src="/static/icon-background.png">
                                        <div class="initials" v-html="extractInitials(note.created_by)"></div>
                                    </div>
                                </span>
                                <div class="content">
                                    <span class="author">{{reply.created_by}}</span>
                                    <div class="metadata">
                                        <span class="date">{{formatDate(reply.updated)}}</span>
                                    </div>
                                    <form v-if="reply.uuid==editNote" class="ui reply form" v-bind:id="'form-'+reply.uuid">
                                        <input type="hidden" name="uuid" v-bind:value="reply.uuid">
                                        <div class="field">
                                            <textarea style="min-height:8em;" v-bind:id="'edit-'+reply.uuid" name="note">{{reply.note}}</textarea>
                                        </div>
                                        <div class="ui blue submit button">Save</div>
                                        <div class="ui red cancel button" v-on:click="cancel()">Cancel</div>
                                    </form>
                                    <div v-if="reply.uuid!=editNote">
                                        <div class="text" v-bind:id="'note-'+reply.uuid" v-html="reply.note.replace(/\r\n/g,'<br>')"></div>
                                        <div class="actions">
                                            <a v-if="index==note.replies.length-1" class="reply" v-on:click="add_reply(reply.uuid)">Reply</a>
                                            <span v-else class="reply">&nbsp;</span>
                                            <span style="position:absolute;right:0px">
                                                <i v-if="auth.role=='admin' || (auth.role=='contributor' && auth.uuid==note.created_by_id) " class="edit outline icon" v-on:click="edit(reply.uuid)" style="cursor:pointer"></i>
                                                <i v-if="auth.role=='admin' || (auth.role=='contributor' && auth.uuid==note.created_by_id) " class="trash alternate outline icon" v-on:click="delete_note(reply.uuid)" style="cursor:pointer"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <form v-if="reply.uuid==addReply" class="ui reply form" id='reply'>
                                        <input v-if="note.hasOwnProperty('items')" type="hidden" name="items" id="items" v-bind:value="[note.items[0]]">
                                        <!-- <input v-else type="hidden" name="items" id="items" value="">-->
                                        <input type="hidden" name="reply_to" v-bind:value="note.uuid">
                                        <div class="field">
                                            <textarea style="height:8em" id="reply-note" name="note"></textarea>
                                        </div>
                                        <div class="ui blue labeled submit icon button">
                                            <i class="icon edit"></i> Add Reply
                                        </div>
                                        <div class="ui red cancel button" v-on:click="cancel()">Cancel</div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div v-if="all_notes_view" class="ui divider"></div>
                    </div>
                </div>
                <div class="two wide column">
                   
                        <div v-if="note.hasOwnProperty('items') && all_notes_view" class="ui large label" v-bind:style="{'background-color':note.note_color}">
                            <router-link style="opacity:1" class="item_href" v-bind:to="'/item/'+note.items[0]">{{note.items[0]}}</router-link>
                        </div>
                    
                        <div v-else-if="all_notes_view" class="ui large label" v-bind:style="{'background-color':note.note_color}">
                            <span>General<br>Comments</span>
                        </div>
                   

                </div>
            </div>

        </div>
        <div v-if="loading" class="ui active bottom attached tab segment">
            <div class="ui active centered inline loader"></div><br>
            <div style='width:100%;text-align:center'>Loading...</div>
        </div>
    </div>

    <div class="ui mini modal" id="deleteConfirm">
        <div class="content">
            <p>Delete the note</p>
        </div>
        <div class="actions">
            <div class="ui red cancel inverted button">
                <i class="remove icon"></i> No
            </div>
            <div class="ui green ok inverted button">
                <i class="checkmark icon"></i> Yes
            </div>
        </div>
    </div>

</div>

</template>


<script>
  export default {
    props: ['primary_item', 'concordances', 'all_notes_view'],
    components: {},

    data() {
      return {
        addReply: "",
        editNote: "",
        noteList: null,
        loading:true,
        show_concordances: true,
        auth: {},
        my_comments: false,
        general_comments: false,
        previousItem: "",
        order_val: 0,
        order: [{
            order_by: "items",
            order_dir: "asc"
          },
          {
            order_by: "items",
            order_dir: "desc"
          },
          {
            order_by: "date",
            order_dir: "asc"
          },
          {
            order_by: "date",
            order_dir: "desc"
          },
        ]
      }
    },

    mounted() {
      if (!this.all_notes_view) {
        if (localStorage.getItem('show_concordances') != null) {
          this.show_concordances = (localStorage.getItem('show_concordances') === 'true');
        }
      }
      if (localStorage.getItem('order') != null) {
        this.order_val = localStorage.getItem('order')
      }


      var localThis = this;
      this.loadData();
      setTimeout(function() {
        localThis.setAddCommentForm();
        localThis.ativateDropdown();
      }, 200)
      axios
        .get('/api/isauth/')
        .then(response => {
          if (response.data.isauth) {
            this.auth.logged = true;
            this.auth.role = response.data.role;
            this.auth.uuid = response.data.uuid;

          }
          else {
            this.auth.logged = false;

          }
        })

    },

    watch: {
      show_concordances: function(to, from) {
        //console.log("shreitems " + to + " ::: " + from);
        localStorage.removeItem('show_concordances');
        localStorage.setItem('show_concordances', this.show_concordances);
        this.loadData();
      },
      my_comments: function(to, from) {
        //console.log("mycomments " + to + " ::: " + from);
        this.loadData();
      },
      general_comments: function(to, from) {
        // console.log("mycomments " + to + " ::: " + from);
        this.loadData();
      },
      order_val: function(to, from) {
        localStorage.removeItem('order');
        localStorage.setItem('order', to);
        this.loadData();
      }

    },
    methods: {
      itemDiveder: function(item) {
        this.previousItem = item;
        return "****************" + item + "**************"
      },
      extractInitials: function(name) {
        return name.substring(0, 1) + name.substr(name.lastIndexOf(' ') + 1, 1);
      },

      formatDate: function(d) {
        var date = new Date(d);
        var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var dd = ('0' + date.getDate()).slice(-2);
        var mon = months[date.getMonth()];
        var yyyy = date.getFullYear();
        var hh = ('0' + date.getHours()).slice(-2);;
        var mm = ('0' + date.getMinutes()).slice(-2);
        return dd + "-" + mon + "-" + yyyy + " " + hh + ":" + mm
      },

      delete_note: function(uuid) {
        var myThis = this;
        $('#deleteConfirm').modal({
          onApprove: function() {
            axios
              .delete('/api/note/' + uuid)
              .then(response => {
                if (response.status == 200) {
                  //    myThis.showMessage('positive', "Note deleted succesfully.");
                  //    myThis.hideMessage(5);
                }
                else {
                  //   myThis.showMessage('negative', "Cannot delete note. Server response: " + response.status);
                }
                myThis.loadData();
              });
          }
        }).modal('show');
      },

      add_reply: function(uuid) {
        var localThis = this;
        this.addReply = uuid;
        this.editNote = "";
        setTimeout(function() {
          localThis.setReplyCommentForm(uuid);
        }, 200)
      },

      edit: function(uuid) {
        var localThis = this;
        this.addReply = "";
        var height = $('#note-' + uuid).height();
        this.editNote = uuid;
        setTimeout(function() {
          $('#edit-' + uuid).height(1.05 * height)
          localThis.setEditCommentForm(uuid);
        }, 200)
      },

      cancel: function() {
        this.editNote = "";
        this.addReply = "";
      },


      extractedRelatedItemsIds: function() {
        var ret = []
        for (var i in this.concordances) {
          ret.push(this.concordances[i].id);
        }
        return ret
      },

      ativateDropdown: function() {
        var localThis = this;
        $('#sort_by').dropdown({
          onChange: function(val) {
            localThis.order_val = parseInt(val);
          }
        });
        $('#sort_by').dropdown('set selected', localThis.order_val);
        /*   if (localStorage.getItem('order') != null) {
             $('#sort_by').dropdown('set selected', localStorage.getItem('order'));
           }*/

        // $('#sort_by').dropdown();
      },

      loadData: function() {
        this.loading = true;
        var localThis = this;
        this.editNote = "";
        this.addReply = "";
      
        var query = this.order[this.order_val];
        // localStorage.removeItem('show_concordances');
        //  localStorage.setItem('show_concordances', this.show_concordances);
        if (!this.all_notes_view) {
          if (this.primary_item != "") {
            query.item_id = [this.primary_item]
            if (this.show_concordances) {
              query.item_id = query.item_id.concat(this.extractedRelatedItemsIds());
            }
          }
        }
        query.my_notes = this.my_comments
        query.general_notes = this.general_comments;
        //console.log(query);
        axios
          .get('/api/notes/', { params: query })
          .then(response => {
            this.noteList = response.data;
          
            this.loading=false;
            this.$emit('notesLoaded', response.data.length);
            // console.log(this.noteList);
            //localThis.ativateDropdown();
          });
      },

      setAddCommentForm: function() {
        var localThis = this;
        var fields = {
          note: 'empty'
        }

        $('#add_comment').form({
          on: 'blur',
          fields: fields,
          onSuccess: function(event, fields) {

            event.preventDefault();
            var formArray = $('form').serializeArray();
            var postBody = {};
            for (var i in formArray) {
              postBody[formArray[i].name] = formArray[i].value;
            }
            axios.post('/api/note', postBody)
              .then(function(response) {
                //console.log(response.status);
                //localThis.$emit('submitNote', response.status);
                $("#note").val("");
                localThis.loadData();
              })
              .catch(function(error) {
                console.log(error);
                //   localThis.$emit('submitNote', response.status);
              });
          }
        });
      },

      setReplyCommentForm: function(uuid) {
        var localThis = this;
        var fields = {
          note: 'empty'
        }
        //  console.log("setting edit form")
        $('#reply').form({
          on: 'blur',
          fields: fields,
          onSuccess: function(event, fields) {
            event.preventDefault();
            var formArray = $('form').serializeArray();
            var postBody = {};
            for (var i in formArray) {
              postBody[formArray[i].name] = formArray[i].value;
            }
            axios.post('/api/note', postBody)
              .then(function(response) {
                //console.log(response.status);
                //localThis.$emit('submitNote', response.status);
                $("#reply-note").val("");
                localThis.loadData();
              })
              .catch(function(error) {
                console.log(error);
                //   localThis.$emit('submitNote', response.status);
              });
          }
        });
      },

      setEditCommentForm: function(uuid) {
        var localThis = this;
        var fields = {
          note: 'empty'
        }
        //  console.log("setting edit form")
        $('#form-' + uuid).form({
          on: 'blur',
          fields: fields,
          onSuccess: function(event, fields) {
            event.preventDefault();
            var formArray = $('form').serializeArray();
            var postBody = {};
            for (var i in formArray) {
              postBody[formArray[i].name] = formArray[i].value;
            }
            axios.put('/api/note', postBody)
              .then(function(response) {
                $("#edit-" + uuid).val("");
                localThis.loadData();
                //     console.log(response);
                //      localThis.$emit('submitNote', response.status);
              })
              .catch(function(error) {
                console.log(error);
                //  myThis.$emit('submitNote', response.status);
              });
          }
        });
      },
    },


  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .opened {
    display: block;
  }

  .closed {
    display: none;
  }

  .italic {
    font-style: italic;
  }

  TD {
    padding: 0px;
  }

  .initials {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: bold;
    font-size: 1.2em;
    color: #b30000;
  }

  .item_id {
    color: #004d99;
  }

  .item_link {
    position: absolute;
    width: 140%;
    text-align: right;
  }

  .item_href {
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/TheNoteList_v2.vue